import React, { useState } from 'react';
import { usePackages } from '../context/PackageContext';
import '../styles/CategoryFilter.css';

const CategoryFilter = () => {
  const { categories, selectedCategory, setSelectedCategory, setSearchQuery } = usePackages();
  const [searchInput, setSearchInput] = useState('');

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    setSearchQuery(value);
  };

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    setSearchInput('');
    setSearchQuery('');
  };

  return (
    <div className="category-filter-glass">
      <div className="search-bar-glass">
        <i className="fas fa-search search-icon"></i>
        <input
          type="text"
          placeholder="Search packages..."
          value={searchInput}
          onChange={handleSearchChange}
          className="search-input-glass"
        />
      </div>
      
      <div className="filter-buttons-glass">
        {categories.map((category) => (
          <button
            key={category}
            className={`filter-btn-glass ${selectedCategory === category ? 'active' : ''}`}
            onClick={() => handleCategoryClick(category)}
          >
            {category}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;
